import React from "react";
import SvgIcon from "../components/UI/SVGIcon";

const isNumber = (char) => {
    return /^\d$/.test(char);
}

const customSort = (valueA, valueB, nodeA, nodeB, isDescending) => {
    if(valueA && valueB) {
        // check for emojis and remove them
        const emojiRegex = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi;
        const aStr = String(valueA).replace(emojiRegex, '');
        const bStr = String(valueB).replace(emojiRegex, '');
        // First: check the values at the end of the string for char like % or k... etc. and remove it
        const lastvalueACharIsNotNumber = !isNumber(valueA[valueA.length - 1]);
        const lastvalueBCharIsNotNumber = !isNumber(valueB[valueB.length - 1]);

        let a = aStr;
        //console.log(valueA.charAt(valueA.length - 1))
        //console.log(isNumber(valueA[valueA.length - 1]))
        let b = bStr;
        if(a === 'N/A') {
            return -1
        }
        if(b === 'N/A') {   
            return 1;
        }
        // remove the last char if is not integer
        if(lastvalueACharIsNotNumber) {
            a = a.slice(0, -1);
        }
        if(lastvalueBCharIsNotNumber) {
            b = b.slice(0, -1);
        }
        // remove '+' at the begining
        if(a.charAt(0) === '+') {
            a = a.slice(1);
        }
        let aNum = parseFloat(a);
        if(b.charAt(0) === '+') {
            b = b.slice(1);
        }
        let bNum = parseFloat(b);
        if (aNum === bNum) return 0;
        else if (aNum === null)  // a is null? last 
        return 1;
        else if (bNum === null)  // b is null? last
        return -1;
        // compare formatted numbers such as "14.5K", "2.65M"... or numbers such as "14.5K%", "2.65M%"
        const isFormattedNumString = (valueA[valueA.length - 1] === 'K' || valueA[valueA.length - 1] === 'M' || valueA[valueA.length - 1] === 'B') ||
                                    (valueB[valueB.length - 1] === 'K' || valueB[valueB.length - 1] === 'M' || valueB[valueB.length - 1] === 'B') ||
                                    (a[a.length - 1] === 'K' || a[a.length - 1] === 'M') ||  
                                    (b[b.length - 1] === 'K' || b[b.length - 1] === 'M');
        if(isFormattedNumString) {
            if(valueA[valueA.length - 1] === 'K' || valueA[valueA.length - 2] === 'K') {
                aNum = aNum * 1000;
            }
            if(valueB[valueB.length - 1] === 'K' || valueB[valueB.length - 2] === 'K') {
                bNum = bNum * 1000;
            }
            if(valueA[valueA.length - 1] === 'M' || valueA[valueA.length - 2] === 'M') {
                aNum = aNum * 1000000;
            }
            if(valueB[valueB.length - 1] === 'M' || valueB[valueB.length - 2] === 'M') {
                bNum = bNum * 1000000;
            }
            if(valueA[valueA.length - 1] === 'B') {
                aNum = aNum * 1000000000;
            }
            if(valueB[valueB.length - 1] === 'B') {
                bNum = bNum * 1000000000;
            }
            //return aNum.toString().localeCompare(bNum.toString()) > 0 ? 1: -1;
        }

        return (aNum > bNum) ? 1 : -1;
    }
    
}

const CallEfHtml = (props) => {
    //AVG_TracingImpact
    let callVal = props.data.AVG_CallImmediateEffect;
    if(typeof(callVal) === 'string') {
        let sliced = callVal.slice(0, callVal.length - 1);
        sliced = parseFloat(sliced);
        //traceVal = sliced;
    }
    return (
        <span>{callVal}</span>
    )
}

const BuyLinkHtml = (props) => {
    return (
        <div>
            {props !== undefined ? (
                <div className="flex-box custom-cell buyLinkFlozz">
                    <div className="ellipsis accent-txt1" style={{'cursor': 'pointer'}}>
                        {/* <a className="ellipsis accent-txt1" href={props.data.BuyLink} style={{'textDecoration': 'none'}} target="_blank" rel="noreferrer">{props.data.BuyLink}</a> */}
                        <a className="ellipsis" href={props.data.BuyLinkFlozz} style={{'textDecoration': 'none'}} target="_blank" rel="noreferrer"></a>
                    </div>
                    {/* <div title="Copy Link"><SvgIcon copyText={props.data.BuyLink} /></div> */}
                </div>
            ) : null}
        </div>
    )
}

const TracingImpactHtml = (props) => {
    const label = props.data.SuccessRate;
    let txtColor;
    if(label) {
        txtColor = label[0] === '-' ? 'red-value-label' : 'green-value-label';
    }
    else {
        txtColor = '';
    }
    
    return (
        <div>
            {props !== undefined ? (
                <div className={txtColor}>{props.data.SuccessRate}</div>
            ) : null}
        </div>
    )
}

const RedOrGreenColoringHtml = (props) => {
    const label = props.data.AVG_TracingImpact;
    const txtColor = label[0] === '-' ? 'red-value-label' : 'green-value-label';
    return (
        <div>
            {props !== undefined ? (
                <div className={txtColor}>{props.data.AVG_TracingImpact}</div>
            ) : null}
        </div>
    )
}


const RedOrGreenColoringPeak = (props) => {
    const label = props.data.AVG_FromCallToPeak;
    const txtColor = label[0] === '-' ? 'red-value-label' : 'green-value-label';
    return (
        <div>
            {props !== undefined ? (
                <div className={txtColor}>{props.data.AVG_FromCallToPeak}</div>
            ) : null}
        </div>
    )
}

const RedOrGreenColoringCallEf = (props) => {
    const label = props.data.AVG_CallImmediateEffect;
    const txtColor = label[0] === '-' ? 'red-value-label' : 'green-value-label';
    return (
        <div>
            {props !== undefined ? (
                <div className={txtColor}>{props.data.AVG_CallImmediateEffect}</div>
            ) : null}
        </div>
    )
}


const TokenContractHtml = (props) => {
    return (
        <div>
            {props !== undefined ? (
                <div className="flex-box custom-cell scanLink">
                    <div className="ellipsis accent-txt1" style={{'cursor': 'pointer'}}>
                        {/* <a className="ellipsis accent-txt1" href={props.data.BuyLink} style={{'textDecoration': 'none'}} target="_blank" rel="noreferrer">{props.data.BuyLink}</a> */}
                        <a className="ellipsis" href={props.data.ScanLink} style={{'textDecoration': 'none'}} target="_blank" rel="noreferrer"></a>
                    </div>
                    {/* <div title="Copy Link"><SvgIcon copyText={props.data.BuyLink} /></div> */}
                </div>
            ) : null}
        </div>
    )
}

const CallGroupImageHtml = (props) => {
    let imageBase64str;
    const folderName = '/callgrimages/';
    let imgUrl = '';
    if(props.data.CryptoGroupImage || props.data.Image || props.data.TokenImage) {
        let imgSrc = props.data.CryptoGroupImage || props.data.Image || props.data.TokenImage;
        imageBase64str = imgSrc.replace(/(\r\n|\n|\r)/gm, "");
        if(imageBase64str && imageBase64str !== '' && !imageBase64str.startsWith('http')) {
            imageBase64str = "data:image/png;base64, " + imgSrc.replace(/(\r\n|\n|\r)/gm, "");
        }
        if(imageBase64str.startsWith('http')) {
            imageBase64str = imgSrc;
        }
        if(imgSrc === null || imageBase64str.startsWith('https://shillguard-001')) {
            // TOP 5 Callers
            const imgName = imgSrc.split('/').pop();
            const img = folderName + imgName;
            imageBase64str = img;
        }
    }
    
    return (
        <div>
            {props !== undefined ? (
                <div className={props.CryptoGroupImage ? 'flex-box custom-cell rounded-img' : 'custom-cell rounded-img'} >
                    {imageBase64str? (
                        <img height={36} src={imageBase64str} alt="CallGroupImage" />
                    ) : null}
                    {/* {props.data.Image ? (<img height={27} src={props.data.Image} alt="CallGroupImage" />) : null} */}
                </div>
            ) : null}
        </div>
    )
}

const addDefaultSrc = (e) =>{
    return e.target.src = '/img/no-image.png'
}

const CallGroupImageWithHeaderHtml = (props) => {
    let imageBase64str;
    const folderName = '/callgrimages/';
    let imgUrl = '';
    if(props.data.CryptoGroupImage || props.data.Image || props.data.TokenImage) {
        let imgSrc = props.data.CryptoGroupImage || props.data.Image || props.data.TokenImage;
        imageBase64str = imgSrc.replace(/(\r\n|\n|\r)/gm, "");
        if(imageBase64str && imageBase64str !== '' && !imageBase64str.startsWith('http')) {
            imageBase64str = "data:image/png;base64, " + imgSrc.replace(/(\r\n|\n|\r)/gm, "");
        }
        if(imageBase64str.startsWith('http')) {
            imageBase64str = imgSrc;
        }
        if(imgSrc === null || imageBase64str.startsWith('https://shillguard-001')) {
            // TOP 5 Callers
            const imgName = imgSrc.split('/').pop();
            const img = folderName + imgName;
            imageBase64str = img;
        }
    }
    
    return (
        <div>
            {props !== undefined ? (
                <div className={props.CryptoGroupImage ? 'flex-box custom-cell rounded-img' : 'custom-cell rounded-img'} >
                    {imageBase64str? (
                        <div className="ellipsis image-name">
                                <img onError={addDefaultSrc} height={36} src={imageBase64str} alt="CallGrImg" />
                                <span className="ellipsis">{props.data.NameOfCallGroup}</span>
                            </div>
                    ) : null}
                    {/* {props.data.Image ? (<img height={27} src={props.data.Image} alt="CallGroupImage" />) : null} */}
                </div>
            ) : null}
        </div>
    )
}

const TokenSymbolHtml = (props) => {
    return (
        <div>{props.data.TokenSymbol}</div>
    )
}

const FullTokenSymbolHtml = (props) => {
    return (
        <div className="custom-cell"><div className="ellipsis">{props.data.TokenName}</div></div>
    )
}

const CallsFullTokenSymbolHtml = (props) => {
    let imageBase64str;
    const folderName = '/callgrimages/';
    let imgUrl = '';
    if(props.data.CryptoGroupImage || props.data.Image || props.data.TokenImage) {
        let imgSrc = props.data.CryptoGroupImage || props.data.Image || props.data.TokenImage;
        imageBase64str = imgSrc.replace(/(\r\n|\n|\r)/gm, "");
        if(imageBase64str && imageBase64str !== '' && !imageBase64str.startsWith('http')) {
            imageBase64str = "data:image/png;base64, " + imgSrc.replace(/(\r\n|\n|\r)/gm, "");
        }
        if(imageBase64str.startsWith('http')) {
            imageBase64str = imgSrc;
        }
        if(imgSrc === null || imageBase64str.startsWith('https://shillguard-001')) {
            // TOP 5 Callers
            const imgName = imgSrc.split('/').pop();
            const img = folderName + imgName;
            imageBase64str = img;
        }
    }
    return (
        <div className="callGroupname">
            {props !== undefined ? (
                <div className={props.CryptoGroupImage ? 'flex-box custom-cell rounded-img' : 'custom-cell rounded-img'} >
                    {props.data.TokenSymbol? (
                        <div className="ellipsis image-name flex-box">
                                <div>
                                    <img onError={addDefaultSrc} height={32} src={imageBase64str} alt="CallGrImg" />
                                </div>
                                <div className="sgt-cell" style={{"flex": "1"}}>
                                    <p><span className="ellipsis inter-bold-16">{props.data.TokenName}</span></p>
                                </div>
                            </div>
                    ) : null}
                    {/* {props.data.Image ? (<img height={27} src={props.data.Image} alt="CallGroupImage" />) : null} */}
                </div>
            ) : null}
        </div>
    )
}


const top5NumberLabel = (data) => {
    return `#${data.node.rowIndex + 1}`;
}

const TOP5CallersName = (props) => {
    return props.data.Name;
}

const TOP5TokensAndVisitedName = (props) => {
    return (
        <div className="top-grid-name">{props.data.Name}</div>
    );
}

const BuyLinkCalls = (props) => {
    return (
        <div>
            {props !== undefined ? (
                <div className="flex-box custom-cell chartLink">
                    <div className="ellipsis accent-txt1" style={{'cursor': 'pointer'}}>
                        {/* <a className="ellipsis accent-txt1" href={props.data.BuyLink} style={{'textDecoration': 'none'}} target="_blank" rel="noreferrer">{props.data.BuyLink}</a> */}
                        <a className="ellipsis" href={props.data.BuyLink} style={{'textDecoration': 'none'}} target="_blank" rel="noreferrer"></a>
                    </div>
                    {/* <div title="Copy Link"><SvgIcon copyText={props.data.BuyLink} /></div> */}
                </div>
            ) : null}
        </div>
    )
}

const FormatDateAndTime = (props) => {
        //props = props.replace(/\s+/g,'T');
        // 2025-09-14T22:05:45
        let date = '';
        const str = props.dateString ? props.dateString.replace(/\s+/g, 'T') : '';
        let d = new Date(str);
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const day = d.getDate();
        const formatedDay = day < 10 ? '0' + day : day;
        //const month = d.getMonth() + 1;
        let year = d.getFullYear();
        //year = year.toString().slice(2, year.length)
        date = formatedDay + ' ' + monthNames[d.getMonth()] + ' ' + year;
        // "12.01.24"
        let h = d.getHours();
        let hours = h < 10 ? '0' + h : h;
        let minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
        let s = d.getSeconds();
        let seconds = s < 10 ? '0' + s : s;
        return (
            <div>
                <p>{date} {hours}:{minutes}:{seconds}</p>
            </div>
        );
    }

const TimeStampHTML = (props) => {
    return (
        <div>
            {props !== undefined ? (
                <div className="flex-box custom-cell vert-line-sep">
                    <FormatDateAndTime dateString={props.data.Timestamp} />
                    {/* <div title="Copy Link"><SvgIcon copyText={props.data.BuyLink} /></div> */}
                </div>
            ) : null}
        </div>
    )
}

function dateComparator(date1, date2) {
    if(date1 !== undefined && date2 !== undefined) {
        date1 = date1.replace(/\s+/g,'T');
        date2 = date2.replace(/\s+/g,'T');
        const dt1 = date1.split('T');
        date1 = dt1[0].split("-").reverse().join("-");
        date1 += 'T' + dt1[1];
        const dt2 = date2.split('T');
        date2 = dt2[0].split("-").reverse().join("-");
        date2 += 'T' + dt2[1];
        const d1 = Date.parse(date1);
        const d2 = Date.parse(date2);
        return d1 - d2;
    }
    else{
        return -1;
    }
}

const TotalMarketCapINHTML = (props) => {
    return (
        <div>
            {props !== undefined && props.data.TotalMarketCapIN ? (
                <div>
                    <p>${props.data.TotalMarketCapIN}</p>
                </div>
            ) : null}
        </div>
    )
}

const TotalMarketCap = (props) => {
    return (
        <div>
            {props !== undefined && props.data.TotalMarketCap ? (
                <div>
                    <p>${props.data.TotalMarketCap}</p>
                </div>
            ) : null}
        </div>
    )
}

const VolumeGenereted_h24 = (props) => {
    return (
        <div>
            {props !== undefined && props.data.VolumeGenereted_h24 ? (
                <div>
                    <p>${props.data.VolumeGenereted_h24}</p>
                </div>
            ) : null}
        </div>
    )
}

export const callersGridColumns = [

    // Home Page
    // Common columns:
    {
        field: 'NameOfCallGroup', 
        headerName: 'Call Group', 
        resizable: true,
        headerClass: 'i-icon',
        headerTooltip: 'The name of the group or individual influencer responsible for making the call.',
    },
    // Token Details page
    // Common columns:
    {field: 'number', valueGetter: "node.rowIndex + 1", headerName: "#", width: 60, sortable: false, suppressSorting: true},
    {
        field: 'Top5TokensImage', 
        headerName: 'Call Group', 
        resizable: true,
        width: 50,
        headerClass: 'i-icon',
        headerTooltip: 'The image of the cryptocurrency token.',
        cellRenderer: CallGroupImageHtml,
    },
    {
        field: 'CryptoGroupImage', 
        headerName: 'Call Group', 
        resizable: true,
        width: 180,
        headerClass: 'i-icon',
        headerTooltip: 'The image of the group or individual influencer responsible for making the call.',
        cellRenderer: CallGroupImageWithHeaderHtml,
    },
    {
        field: 'TokenName', 
        headerName: 'Token', 
        resizable: true,
        width: 80,
        headerClass: 'i-icon',
        headerTooltip: 'The Token symbol of the cryptocurrency token being called last.',
        cellRenderer: TokenSymbolHtml,
    },
    {
        field: 'FullTokenName', 
        headerName: 'FullTokenName', 
        resizable: true,
        headerClass: 'i-icon',
        width: 140,
        tooltipValueGetter: (p) => p.data.TokenName,
        headerTooltip: 'The name of the cryptocurrency token being called last.',
        cellRenderer: FullTokenSymbolHtml,
    },
    {
        field: 'CallsFullTokenName', 
        headerName: 'Token Name', 
        resizable: true,
        headerClass: 'i-icon',
        width: 175,
        tooltipValueGetter: (p) => p.data.TokenName,
        valueGetter: (p) => p.data.TokenName,
        headerTooltip: 'The name of the cryptocurrency token being called last.',
        cellRenderer: CallsFullTokenSymbolHtml,
    },
    //OrderNumber
    {
        field: 'OrderNumber', 
        headerName: 'OrderNumber', 
        resizable: true,
        headerClass: 'i-icon',
        headerTooltip: 'The name of the cryptocurrency token being called last.',
    },
    {
        field: 'BuyLink', 
        headerName: 'Buy', 
        resizable: true, 
        width: 50,
        enableCellTextSelection: true,
        headerTooltip: 'A link to a platform where users can purchase the mentioned token.',
        headerClass: 'buyHeader',
        cellRenderer: BuyLinkHtml,
    },
    {
        field: 'TotalMarketCapIN', 
        headerName: 'CALL M.CAP', 
        resizable: true,
        width: 130,
        headerClass: 'i-icon',
        headerTooltip: 'The market capitalization of the token at the time of the call.',
        valueGetter: (p) => p.data.TotalMarketCapIN,
        comparator: customSort,
        cellRenderer: TotalMarketCapINHTML
    },
    {
        field: 'TotalMarketCap', 
        headerName: 'M.CAP', 
        resizable: true, 
        width: 110,
        headerClass: 'i-icon',
        headerTooltip: 'The current market capitalization of the token.' ,
        valueGetter: (p) => p.data.TotalMarketCap,
        comparator: customSort,
        cellRenderer: TotalMarketCap
    },
    {
        field: 'MarketCap', 
        headerName: 'MktCap', 
        resizable: true, 
        width: 80,
        headerClass: 'i-icon',
        headerTooltip: 'The current market capitalization of the token.' ,
        comparator: customSort
    },
    {
        field: 'Liquidity',
        headerName: 'Liquidity', 
        resizable: true, 
        width: 110,
        headerClass: 'i-icon',
        valueGetter: (p) => p.data.Liquidity,
        headerTooltip: 'The current Liquidity.' ,
        comparator: customSort
    },
    {
        field: 'ImpactOfCall', 
        headerName: 'CALL EFC', 
        resizable: true, 
        width: 110,
        headerClass: 'i-icon',
        headerTooltip: 'Maximal positive  market capitalization change  of the token in the first 15 minutes after the call was made.' ,
        comparator: customSort
    },
    {
        field: 'SuccessRate', 
        headerName: 'Trace', 
        resizable: true,
        width: 110,
        headerClass: 'i-icon',
        headerTooltip: "An ongoing assessment of the token's market capitalization movement and impact since the call.",
        cellRenderer: TracingImpactHtml,
        comparator: customSort
    },
    {
        field: 'FromCalltoPeak', 
        headerName: 'Peak',
        resizable: true,
        width: 110,
        headerClass: 'i-icon',
        valueGetter: (p) => p.data.FromCalltoPeak,
        headerTooltip: "The percentage change in price from the time of the call to the token's all-time high (ATH).",
        comparator: customSort
    },
    // Extra Columns:
    {
        field: 'TokenHash', 
        headerName: 'Scan', 
        resizable: true,
        width: 50,
        headerTooltip: "The unique cryptographic identifier associated with the token on the blockchain.",
        headerClass: 'caHeader',
        cellRenderer: TokenContractHtml,
    },
    {
        field: 'BuyLinkCalls', 
        headerName: 'Chart', 
        resizable: true,
        width: 50,
        headerTooltip: "The unique cryptographic identifier associated with the token on the blockchain.",
        headerClass: 'chartHeader',
        cellRenderer: BuyLinkCalls,
    },
    {
        field: 'Chain', 
        headerName: 'Network', 
        width: 90,
        resizable: true,
        headerClass: 'i-icon',
        headerTooltip: "Chain The blockchain on which the cryptocurrency token operates."
    },
    {
        field: 'PriceUSD', 
        headerName: 'Price', 
        resizable: true,
        headerClass: 'i-icon',
        headerTooltip: "Current price of the token in USD.",
    },
    {
        field: 'VolumeGenereted_h24', 
        headerName: 'Vol (24)', 
        width: 120,
        resizable: true,
        headerClass: 'i-icon',
        valueGetter: (p) => p.data.VolumeGenereted_h24,
        comparator: customSort,
        headerTooltip: "The trading volume of the token.",
        cellRenderer: VolumeGenereted_h24
    },
    {
        field: 'Volume', 
        headerName: 'Volume', 
        width: 100,
        resizable: true,
        headerClass: 'i-icon',
        headerTooltip: "The trading volume of the token.",
    },
    // {field: 'ATX', headerName: 'ATX', resizable: true },
    {
        field: 'Holders', 
        headerName: 'Holders', 
        resizable: true,
        headerClass: 'i-icon',
        headerTooltip: "The number of token holders or addresses holding the cryptocurrency.",
    },
    {
        field: 'CryptoTokenCall', 
        headerName: 'Call Description', 
        resizable: true,
        headerClass: 'i-icon',
        headerTooltip: "Contains the text or description of the cryptocurrency call made by the group or influencer.",
        tooltipField: 'CryptoTokenCall',
    },
    {
        field: 'Source', 
        headerName: 'Source', 
        resizable: true,
        headerClass: 'i-icon',
        headerTooltip: "Platform or channel from which the cryptocurrency call or recommendation originated.",
        // headerComponentParams: {
        //     template: infoHeaderTemplate()
        // }
    },
    {
        field: 'Timestamp', 
        headerName: 'Date', 
        resizable: true,
        width: 200,
        tooltipValueGetter: (p) => p.value,
        valueGetter: (p) => p.value,
        headerClass: 'i-icon',
        headerTooltip: "Day/Month/Year/UTC time of the call.",
        comparator: dateComparator,
        cellRenderer: TimeStampHTML
    },
    {field: 'Top5Number', valueGetter: top5NumberLabel, headerName: "#", width: 40, sortable: false, suppressSorting: true},
    {
        field: 'Image', 
        headerName: 'Image', 
        resizable: true,
        width: 50,
        headerClass: 'i-icon',
        headerTooltip: 'The image of the group or individual influencer responsible for making the call.',
        cellRenderer: CallGroupImageHtml,
    },
    {
        field: 'Name', 
        headerName: 'Name', 
        resizable: true,
        width: 100,
        headerClass: 'i-icon',
        headerTooltip: 'The name of the cryptocurrency token being called last.',
    },
    {
        field: 'TOP5TokensName', 
        headerName: 'Name', 
        resizable: true,
        width: 100,
        headerClass: 'i-icon',
        cellRenderer: TOP5TokensAndVisitedName,
        headerTooltip: 'The name of the cryptocurrency token being called last.',
    },
    {
        field: 'TOP5CallersName', 
        headerName: 'Name', 
        resizable: true,
        width: 100,
        headerClass: 'i-icon',
        headerTooltip: 'The name of the cryptocurrency caller being called last.',
        cellRenderer: TOP5CallersName,
    },
    {
        field: 'TOP5VisitedName', 
        headerName: 'Name', 
        resizable: true,
        width: 100,
        headerClass: 'i-icon',
        headerTooltip: 'The name of the cryptocurrency caller being called last.',
        cellRenderer: TOP5TokensAndVisitedName,
    },
    {
        field: 'BuyLinkTop5', 
        headerName: 'Buy', 
        resizable: true, 
        width: 113,
        enableCellTextSelection: true,
        headerClass: 'i-icon',
        headerTooltip: 'A link to a platform where users can purchase the mentioned token.',
        cellRenderer: BuyLinkHtml,
    },
    {
        field: 'AVG_CallImmediateEffect', 
        headerName: 'CallEfc', 
        resizable: true, 
        width: 85,
        headerClass: 'i-icon',
        headerTooltip: 'Maximal positive  market capitalization change  of the token in the first 15 minutes after the call was made.' ,
        comparator: customSort,
        cellRenderer: RedOrGreenColoringCallEf,
    },
    {
        field: 'AVG_FromCallToPeak', 
        headerName: 'Peak', 
        resizable: true, 
        width: 85,
        headerClass: 'i-icon',
        headerTooltip: "The percentage change in price from the time of the call to the token's all-time high (ATH).",
        comparator: customSort,
        cellRenderer: RedOrGreenColoringPeak
    },
    {
        field: 'AVG_TracingImpact', 
        headerName: 'Trace', 
        resizable: true, 
        width: 85,
        headerClass: 'i-icon',
        headerTooltip: "An ongoing assessment of the token's market capitalization movement and impact since the call.",
        comparator: customSort,
        cellRenderer: RedOrGreenColoringHtml,
    }
]